export default "__VITE_ASSET__D$GWANML__"